export enum Permissions {
    WRITE_BRAND = 'write:brand',
    READ_BRAND = 'read:brand',
    READ_USER = 'read:user',
    WRITE_USER = 'write:user',
    DELETE_USER = 'delete:user',
    LIST_USERS = 'list:users',
    READ_DATAPOINT_DOC = 'read:datapoint-doc',
    READ_MY_BRAND_DASHBOARD = 'read:my-brand-dashboard',
    READ_MY_COMPETITION_DASHBOARD = 'read:my-competition-dashboard',
    READ_MY_CAMPAIGNS_DASHBOARD = 'read:my-campaigns-dashboard',
    READ_COPILOT_SCREEN = 'read:copilot-screen',
    SEND_COPILOT_MESSAGE = 'send:copilot-message',
    READ_MESSAGING_SCREEN = 'read:messaging-screen',
    READ_ACCOUNT = 'read:account',
    WRITE_ACCOUNT = 'write:account',
    DELETE_ACCOUNT = 'delete:account',
    READ_AI_PRESENCE_SCREEN = 'read:ai-presence-screen',
    READ_POLARIS_ALERTS = 'read:polaris-alerts',
    WRITE_POLARIS_ALERTS = 'write:polaris-alerts',
    READ_SIGNAL = 'read:signal',
    READ_TRIAL = 'read:trial',
    WRITE_TRIAL = 'write:trial',
    READ_SOCIAL_OVERVIEW_SCREEN = 'read:social-overview-screen',
    SEND_POLARIS_V2_MESSAGE = 'send:polaris-v2-message',
    SELECT_POLARIS_MODEL_VERSION = 'select:polaris-model-version'
}
